(function () {
  function setupRelatedRail(rail) {
    if (!rail || rail.dataset.lwpCarouselReady === 'true') return;

    const cards = rail.querySelectorAll('.lwp-related-card');
    if (cards.length < 2) return;

    rail.dataset.lwpCarouselReady = 'true';
    const intervalMs = parseInt(rail.dataset.lwpAutoplay, 10) || 3000;
    let timer = null;

    function getStep() {
      const firstCard = rail.querySelector('.lwp-related-card');
      if (!firstCard) return 0;
      const styles = window.getComputedStyle(rail);
      const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return firstCard.getBoundingClientRect().width + gap;
    }

    function getMaxScroll() {
      return Math.max(0, rail.scrollWidth - rail.clientWidth - 2);
    }

    function slideNext() {
      if (document.hidden) return;
      if (rail.matches(':hover') || rail.querySelector(':focus')) return;

      const maxScroll = getMaxScroll();
      const step = getStep();
      if (!step || maxScroll <= 5) return;

      if (rail.scrollLeft + step >= maxScroll) {
        rail.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        rail.scrollBy({ left: step, behavior: 'smooth' });
      }
    }

    function start() {
      stop();
      timer = window.setInterval(slideNext, intervalMs);
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    rail.addEventListener('pointerenter', stop);
    rail.addEventListener('pointerleave', start);
    rail.addEventListener('focusin', stop);
    rail.addEventListener('focusout', start);
    window.addEventListener('resize', function () {
      rail.scrollTo({ left: 0, behavior: 'auto' });
    });

    start();
  }

  function scanRelatedRails(root) {
    (root || document).querySelectorAll('.lwp-related__rail[data-lwp-autoplay]').forEach(setupRelatedRail);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scanRelatedRails(document); });
  } else {
    scanRelatedRails(document);
  }

  const observer = new MutationObserver(function () {
    scanRelatedRails(document);
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();

/* LED Auto: whole-krona display for the custom Wattz product landing page. */
(function () {
  const PRICE_SELECTOR = [
    '[data-lwp-desktop-total-price]',
    '[data-lwp-mobile-total-price]',
    '.lwp-compare',
    '.lwp-pair-bundle__copy > span',
    '.lwp-related-card__bottom > strong'
  ].join(', ');

  function isSekPage() {
    const marker = document.querySelector(
      '[data-lwp-desktop-total-price][data-currency-code="SEK"], ' +
      '[data-lwp-mobile-total-price][data-currency-code="SEK"]'
    );

    const activeCurrency = window.Shopify && window.Shopify.currency
      ? window.Shopify.currency.active
      : '';

    return Boolean(marker) || activeCurrency === 'SEK' || /^\/sv-se(?:\/|$)/i.test(window.location.pathname);
  }

  function formatWholeSek(element) {
    if (!element) return;
    if (element.closest('[data-lwp-klarna-box], [data-lwp-klarna-modal]')) return;

    const explicitCurrency = element.dataset ? element.dataset.currencyCode : '';
    if (explicitCurrency && explicitCurrency !== 'SEK') return;

    const rawText = (element.textContent || '').replace(/\u00a0/g, ' ').trim();
    if (!rawText) return;

    const numericText = rawText
      .replace(/[^0-9,.-]/g, '')
      .replace(/\.(?=\d{3}(?:\D|$))/g, '')
      .replace(',', '.');

    const value = Number(numericText);
    if (!Number.isFinite(value)) return;

    const wholeKr = Math.round(value);
    const formatted = new Intl.NumberFormat('sv-SE', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(wholeKr) + ' kr';

    if ((element.textContent || '').trim() !== formatted) {
      element.textContent = formatted;
    }
  }

  function scanWholeSekPrices() {
    if (!isSekPage()) return;
    document.querySelectorAll(PRICE_SELECTOR).forEach(formatWholeSek);
  }

  function startWholeSekFix() {
    scanWholeSekPrices();

    const priceObserver = new MutationObserver(function () {
      scanWholeSekPrices();
    });

    priceObserver.observe(document.documentElement, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startWholeSekFix, { once: true });
  } else {
    startWholeSekFix();
  }
})();
